import { getCloudinaryUrl } from 'config/helpers';

export function getRescueFaillingProjectImageUrl(
  imageSrc,
  parameters = 'f_auto,q_auto',
) {
  return getCloudinaryUrl(`rescue-failing-project/${imageSrc}`, parameters);
}
